import { render, staticRenderFns } from "./PixDetail.vue?vue&type=template&id=6c188806&scoped=true"
import script from "./PixDetail.vue?vue&type=script&lang=js"
export * from "./PixDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c188806",
  null
  
)

export default component.exports